import { SquareIcon } from 'styling/GlobalStyles'
import { GlobalViewWidget, GlobalViewWidgetContent, GloblViewWidgetTitle } from '../GlobalView.styled'
import { BodyText } from 'styling/Typography'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { FuelIcon } from 'assets/icons/FuelIcon'

export const GLFuelWidget = () => {
    const { machines } = useSelector((state: RootState) => state.globalView)

    const countMachinesByFuelCondition = (
        condition: (fuelPercent: number) => boolean
    ): number => {
        return machines?.filter(machine => condition(machine?.vehicle?.fuelRemainingPercent))?.length
    }


    return <GlobalViewWidget>
        <GloblViewWidgetTitle>
            <SquareIcon color='#ff9900' >
                <FuelIcon />
            </SquareIcon>
            <BodyText weight='bold' >Fuel</BodyText>
        </GloblViewWidgetTitle>
        <GlobalViewWidgetContent>
            <BodyText  >Optimal: <span className='bold' >{countMachinesByFuelCondition(f => f > 75)}</span></BodyText>
            <BodyText >Medium: <span className='bold' >{countMachinesByFuelCondition(f => f <= 75 && f >= 35)}</span></BodyText>
            <BodyText >Low: <span className='bold' >{countMachinesByFuelCondition(f => f < 35 && f >= 6)}</span></BodyText>
            <BodyText  >Warning: <span className='bold' >{countMachinesByFuelCondition(f => f <= 5)}</span></BodyText>
        </GlobalViewWidgetContent>
    </GlobalViewWidget>
}